class CC_Product {
    constructor(product, options = {}){
        this.options = Object.assign(
            {},
            {    
                "product_id" : "",
                trads : {}
            }, 
            options
        );  

        this.product = product;
        const sPlusTitle = this.product.querySelectorAll(".product-right .section-plus h2");
        const itemFormula = this.product.querySelectorAll(".formula .title");
        const inciBtn = this.product.querySelector(".inci .btn");
        const variants = this.product.querySelectorAll(".variant");
        this.sliderBoucle = null;
        this.sliderReaCurrent = 0; 
        this.sliderReasCount = document.querySelectorAll(".content-reas .rea").length;
        this.recharge = false;

        if(sPlusTitle.length > 0){
            sPlusTitle.forEach(t => {
                t.addEventListener("click", () => {
                    var sectionPlus = t.closest(".section-plus");
                    sectionPlus.classList.toggle("close");  
                });
            });
        }
        
        if(itemFormula.length > 0){
            itemFormula.forEach(i => {
                i.addEventListener("click", () => {
                    var formula = i.closest(".formula");
                    if(formula.querySelector(".description") != null){
                        formula.classList.toggle("open");  
                    }
                });
            });
        }
        
        if(inciBtn != null){
            inciBtn.addEventListener("click", () => {
                var cInci = inciBtn.closest(".inci");
                cInci.classList.toggle("on");  
            }); 
        }

        if(document.querySelector(".content-add-to-cart-fixe") != null){
            window.addEventListener("scroll", () => {
                this.addToCartFixedDesk(window.scrollY);
            });
        }

        if(document.querySelector(".content-reviews-min") != null){
            document.querySelector(".content-reviews-min").addEventListener("click", () => {
                let topAvis = document.querySelector(".jdgm-review-widget").offsetTop - 100;
                window.scroll(0, topAvis);
            });
        }
        
        if(variants.length > 0){
            variants.forEach(variant => {
                variant.addEventListener("click", (e) => {
                    if(!variant.classList.contains("selected")){
                        const dataId = variant.getAttribute("data-id");  
                        const dataPrice = variant.getAttribute("data-price");  
                        const dataCompareAtPrice = variant.getAttribute("data-compare_at_price");  

                        document.querySelectorAll(".variant.selected").forEach(v => {
                            v.classList.remove("selected");
                        });  
                        this.majProductData(variant.dataset);  
                        document.querySelectorAll(".variant[data-id='" + dataId + "']").forEach(v => {
                            v.classList.add("selected");
                        });
                        //slider.majMedias(dataId);
                        //slider.reset();
                    }   
                });
            });
        }

        document.querySelectorAll(".content-cat-produit .menu li").forEach(eMenu => {
            eMenu.addEventListener("click", () => { 
                if(!eMenu.classList.contains("active")){ 
                    document.querySelector(".content-cat-produit .menu li.active").classList.remove("active");
                    document.querySelector(".content-cat-produit .cat.active").classList.remove("active");
                    let cat = eMenu.getAttribute("data-cat");
                    document.querySelector(`.content-cat-produit .cat[data-cat=${cat}]`).classList.add("active");
                    eMenu.classList.add("active");
                }
            });
        });
        
        document.querySelectorAll(".content-complement-list .content-list .list h3").forEach(t => {
            t.addEventListener("click", () => {
                t.closest("li").classList.toggle("open");
            });
        });
        
        document.querySelectorAll(".content-complement-list .content-list .list .blacklist ul li h5").forEach(item => {
            item.addEventListener("click", (e) => { 
                item.closest("li").classList.toggle("open");
            });
        }); 
        
        document.querySelectorAll(".content-skincare-list .content-list .list h3").forEach(t => {
            t.addEventListener("click", () => {
                t.closest("li").classList.toggle("open");
            });
        });
        
        document.querySelectorAll(".content-toggle .title").forEach(title => {
            title.addEventListener("click", (e) => { 
                title.closest(".content-toggle").classList.toggle("on");
            });
        }); 

        if(document.querySelector(".content-select-variants.select-mode") != null){
            document.querySelector(".content-select-variants.select-mode .choose").addEventListener("click", () => {
                document.querySelector(".content-select-variants.select-mode").classList.toggle("open");
            });
        } 
        
        if(this.getParams("variant") != null){
            if(document.querySelector(".select-variants") != null){
                let vid = this.getParams("variant");
                document.querySelector(`.select-variants .variant[data-id="${vid}"]`).click();
            }
        }

        if(document.querySelector(".show-more") != null){
            document.querySelector(".show-more").addEventListener("click", () => {
                let link = document.querySelector(".show-more.show").getAttribute("data-href");
                //this.getReviews(link, true);
            });
        }

        if(document.querySelector(".content-conditionnement") != null){
            document.querySelectorAll(".content-conditionnement ul li").forEach(li => {
                li.addEventListener("click", (e) => { 
                    document.querySelector(".content-conditionnement ul li.active").classList.remove("active");
                    e.currentTarget.classList.add("active");
                    console.log(e.currentTarget);
                    if(e.currentTarget.classList.contains("recharge")){
                        this.recharge = true;
                    }else{
                        this.recharge = false;
                    }
                    let obj = {
                        id : e.currentTarget.getAttribute("data-id"),
                        priceWm : e.currentTarget.getAttribute("data-price"),
                    }
                    this.majProductData(obj);    
                });
            });
        }

        //this.getRate();

        if(document.querySelector(".content-reas") != null && this.sliderReasCount > 1){
            this.sliderReasPlay();
        }

        const questions = document.querySelectorAll(".content-faq .q h3");

        if(questions.length > 0){
            questions.forEach(i => {
                i.addEventListener("click", () => {
                    var parent = i.closest(".q-r");
                    parent.classList.toggle("open");  
                });
            });  
        }
    }

    formatPrice(price, currency){
        switch(currency){
            case "EUR" : var devise = "€"; break;
            default : var devise = "€";  
        }
        return (parseInt(price) / 100).toFixed(2) + devise;
    }  
    
    addToCartFixedDesk(wScroll){  
        var targetPos = document.querySelector(".content-main-infos .content-add-to-cart").offsetTop; 
        if(wScroll > targetPos){
            document.querySelector(".content-add-to-cart-fixe").classList.add("show"); 
        }else{
            document.querySelector(".content-add-to-cart-fixe").classList.remove("show");
        }
    }
    
    
    
    majProductData(datas){ 
        console.log(datas);
        document.querySelectorAll(".product-right .add-to-cart").forEach(addToCart => { 
            addToCart.setAttribute("data-vid", datas.id); 
            console.log(datas);
            if(typeof datas.option != "undefined" && datas.option != ""){
                addToCart.querySelector(".contenance").textContent = datas.option;
            } 
            if(datas.compareAtPriceWm != "" && parseInt(datas.compareAtPriceWm) > parseInt(datas.price)){
                addToCart.querySelector(".oldprice").innerHTML = datas.compareAtPriceWm;
            }else{
                addToCart.querySelector(".oldprice").innerHTML = "";
            }
            console.log(datas.priceWm);
            if(typeof datas.priceWm != "undefined"){
                addToCart.querySelector(".price .currentprice").innerHTML = datas.priceWm;
            }
        });
    }

    getParams(parameterName) {
        var result = null,
            tmp = [];
        location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
        tmp = item.split("=");
        if (decodeURIComponent(tmp[0]) === parameterName) result = decodeURIComponent(tmp[1]);
        });
        return result;
    } 

    async getReviews(link, add = false){
        const callReviews =  link != "" ? await fetch(`${link}`) : await fetch(`https://api.okendo.io/v1/stores/1f2ad7a3-26e6-426f-805f-03e1819bc9e5/products/shopify-${this.options.product_id}/reviews`);
        const repReviews = await callReviews.json();  
        console.log(repReviews);
        if(typeof repReviews.nextUrl != "undefined" && repReviews.nextUrl != ""){
            document.querySelector(".show-more").classList.add("show");
            document.querySelector(".show-more").setAttribute("data-href", "https://api.okendo.io/v1" + repReviews.nextUrl);
        }else{
            if(document.querySelector(".show-more").classList.contains("show")){
                document.querySelector(".show-more").classList.remove("show");
            }
        }
        this.buildReviews(repReviews.reviews, add); 
    } 

    async getRate(){
        const callRate =  await fetch(`https://api.okendo.io/v1/stores/1f2ad7a3-26e6-426f-805f-03e1819bc9e5/products/shopify-${this.options.product_id}/review_aggregate`);
        const repRate = await callRate.json();  
        const nbReviews = repRate.reviewAggregate.reviewCount;
        let totalRate = 0;
        if(nbReviews > 0){
            Object.entries(repRate.reviewAggregate.reviewCountByLevel).forEach(level => { 
                const match = level[0].match(/\d+/);
                const number = match ? parseInt(match[0], 10) : null; 
                totalRate += number * level[1];
            }); 
            let rate = (totalRate / nbReviews ).toFixed(1); 
            this.getReviews(""); 
            this.buildScoreReviewsMin(rate, nbReviews, document.querySelector(".content-reviews-min"));
            this.buildScoreReviewsMin(rate, nbReviews, document.querySelector(".content-reviews"));
        } 
    } 

    buildScoreReviewsMin(score, count, target){   
        var noteT = parseInt(score);
        var noteR = Number(score); 
        var noteE = Math.floor((noteR - noteT) * 10) / 10;   
        if(noteE !== 0){
            var decimal = true;
        }else{
            var decimal = false;
        } 
        for(let i = 1; i <= noteT; i++){
            target.querySelector(".star:nth-child(" + i + ")").classList.add("active");
        }
        if(decimal){ 
            target.querySelector(".star:nth-child(" + (noteT + 1) + ")").classList.add("active-s-"+(noteE*10)); 
        }   
        if(target.querySelector(".note") != null){
            target.querySelector(".note").innerHTML = score + "/5"; 
        } 
        if(target.querySelector(".count") != null){
            target.querySelector(".count").innerHTML = count + " " + this.options.trads.reviews; 
        } 
        if(target.classList.contains("hide")){
            target.classList.remove("hide");
        }
    }

    createElementWithClass(type, className){
        var element = document.createElement(type);
        element.classList.add(className);
        return element;
    }

    buildReviews(data, add){
            
        if(!add){
            document.querySelector(".content-reviews .reviews-right .reviews").innerHTML = "";
        }

        data.forEach(r => { 
            var review = this.createElementWithClass("div", "review");   
        
            var reviewName = this.createElementWithClass("div", "review-name"); 
            reviewName.innerHTML = r.reviewer.displayName;
    
            var reviewLeft = this.createElementWithClass("div", "r-left");  
            var reviewRight = this.createElementWithClass("div", "r-right");    
            var reviewContent = this.createElementWithClass("div", "review-content");  
    
            var reviewDate = this.createElementWithClass("div", "review-date");   
            reviewDate.innerHTML = r.dateCreated.split("T")[0];
    
            var stars = this.createElementWithClass("div", "stars");  
    
            for(let i=0; i<5; i++){
                var star = this.createElementWithClass("div", "star");   
                stars.appendChild(star); 
            } 
     
            this.buildScoreReviewsMin(r.rating, "", stars);

            var titleReview = this.createElementWithClass("div", "title"); 
            titleReview.innerHTML = r.title; 
            
            reviewLeft.appendChild(reviewName);
            reviewLeft.appendChild(reviewDate); 
            review.appendChild(reviewLeft); 
            reviewRight.appendChild(stars);
            reviewRight.appendChild(titleReview); 
     
            var checkWords = r.body.split(" ");
            if(checkWords.length > 20 && (checkWords.length - 20) > 10){
                var reviewContentShow = document.createElement("div");
                reviewContentShow.classList.add("r-show");
                reviewContentShow.innerHTML = this.sentenceStart(r.body, 20) + `<span class="c-etc"><span class="etc">...</span></span>`;
    
                var reviewBtn = document.createElement("div");
                reviewBtn.classList.add("r-btn");
                reviewBtn.innerHTML = this.options.trads.read_more;
    
                var reviewContentHide = document.createElement("div");
                reviewContentHide.classList.add("r-hide");
                reviewContentHide.innerHTML = this.sentenceEnd(r.body, 20);
                
    
                reviewContent.appendChild(reviewContentShow);  
                reviewContent.appendChild(reviewBtn);   
                reviewContent.appendChild(reviewContentHide);   
                reviewRight.appendChild(reviewContent); 
    
                reviewBtn.addEventListener("click", (e) => {
                    reviewContent.classList.add("show");
                });
            }else{
                reviewContent.innerHTML = r.body;
                reviewRight.appendChild(reviewContent);  
            }  

            if(typeof r.reviewReply != "undefined" && r.reviewReply != "" ){
                var contentReplyBtn = this.createElementWithClass("button", "show-content-reply"); 
                contentReplyBtn.textContent = this.options.trads.read_answer;
                var contentReply = this.createElementWithClass("div", "content-reply"); 
                contentReply.innerHTML = r.reviewReply;
                reviewRight.appendChild(contentReplyBtn);
                reviewRight.appendChild(contentReply);
                contentReplyBtn.addEventListener("click", () => {
                    contentReplyBtn.classList.add("hide");
                    contentReply.classList.add("open");
                });
            } 
            
            review.appendChild(reviewRight); 
            document.querySelector(".content-reviews .reviews-right .reviews").appendChild(review); 
     
        }); 
    }

    addZero (number){
        if (number < 10) {
            number = "0" + number;
        }
        return number;
    }
    formatDate(date){
        var day = addZero(date.getDate());
        var month = addZero(date.getMonth()+1);
        var year = addZero(date.getFullYear());
        return day + '-' + month + '-' + year;
    }
    sentenceStart(s, n){
        var lw = n + 1;
        return s.split(" ").splice(0,n).join(" ");
    }
    sentenceEnd(s, n){  
        return s.split(" ").slice(n).join(" ");
    }


    resetSliderReas(){ 
        this.sliderPromoCurrent = 0;
        document.querySelector(".content-reas .slider").style.transition = 'all 0s ease';
        document.querySelector(".content-reas .slider").style.transform = `translateX(0px)`;  
        document.querySelector(".content-reas .slider").offsetHeight;
        document.querySelector(".content-reas .slider").style.transition = ""; 
    }

    sliderReasPause(){ 
        clearInterval(this.sliderBoucle);
        this.sliderBoucle = null;
    } 

    sliderReasPlay(){ 
        if (this.sliderBoucle) {
            clearInterval(this.sliderBoucle);
            this.sliderBoucle = null;
        }
        this.sliderBoucle = setInterval(() => { 
            this.sliderReaCurrent++; 
            const slider = document.querySelector(".content-reas .slider");
            const calT = -(this.sliderReaCurrent * (slider.offsetWidth));
            slider.style.transition = 'transform 0.3s ease';
            slider.style.transform = `translateX(${calT}px)`;  
            if (this.sliderReaCurrent === this.sliderReasCount - 1) {
                document.querySelector(".content-reas .bullet.active").classList.remove("active");
                document.querySelectorAll(".content-reas .bullet")[0].classList.add("active");
                setTimeout(() => {
                    slider.style.transition = 'none'; 
                    slider.style.transform = 'translateX(0px)';
                    this.sliderReaCurrent = 0;
    
                    slider.offsetHeight;
                    slider.style.transition = 'transform 0.3s ease'; 
                }, 300); 
            }else{
                document.querySelector(".content-reas .bullet.active").classList.remove("active");
                document.querySelectorAll(".content-reas .bullet")[this.sliderReaCurrent].classList.add("active");
            }
        }, 3000); 
    } 
}





 

